import { css } from '@emotion/react'
import { useFormContext, get } from 'react-hook-form'
import { Font } from "@moneyforward/mfx_biz_react_components";
import { color } from '@/styles/theme'

type Props = {
  name: string
  className?: string
}
export const FormErrorMessage = (props: Props) => {
  const { formState } = useFormContext()
  const error = get(formState.errors, props.name, null)

  return error ? (
    <Font variant="s" css={style} className={props.className}>
      {error.message}
    </Font>
  ) : null
}

const style = css({
  color: color.attention,
})
